import { Component, OnDestroy } from '@angular/core';
import { DataTypeEnum } from 'src/app/constants/data-type.enum';
import { DocumentModel } from 'src/app/models/document.model';
import { CreateColumn, CreateDefaultBasicColumn, TableColumn } from 'src/app/models/tableColumn';
import { RequestBuilderService } from '../request-builder.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BuilderRequest } from 'src/app/models/requests';
import { DocumentActor } from 'src/app/models/actors';

@Component({
  selector: 'app-step-3',
  templateUrl: './step-3.component.html'
})
export class Step3Component implements OnDestroy {
    private requestSubscription: Subscription | null = null;
    private documentsSubscription: Subscription | null = null;
    private personsSubscription: Subscription | null = null;
    private actorsSubscription: Subscription | null = null;
    public request: BuilderRequest | null = null;
    public documents: DocumentModel[] = [];
    public actors: DocumentActor[] = [];
    public persons: DocumentActor[] = [];

    constructor(private requestBuilderService: RequestBuilderService, private translateService: TranslateService) {
        this.requestSubscription = this.requestBuilderService.request$.subscribe((request: BuilderRequest) => {
            this.request = request;
        });
        this.documentsSubscription = this.requestBuilderService.documents$.subscribe((documents: DocumentModel[]) => {
            this.documents = documents;
        });
        this.personsSubscription = this.requestBuilderService.persons$.subscribe((persons: DocumentActor[]) => {
            this.persons = persons;
        });
        this.actorsSubscription = this.requestBuilderService.actors$.subscribe((actors: DocumentActor[]) => {
            this.actors = actors;
        });
    }

    ngOnDestroy(): void {
        this.request = null;
        this.documents = [];
        this.persons = [];
        this.actors= [];

        if(this.requestSubscription){
            this.requestSubscription.unsubscribe();
        }
        if(this.documentsSubscription){
            this.documentsSubscription.unsubscribe();
        }
        if(this.personsSubscription){
            this.personsSubscription.unsubscribe();
        }
        if(this.actorsSubscription){
            this.actorsSubscription.unsubscribe();
        }
    }

    titleofChecklist() {
        return this.translateService.instant('Checklist.PersonsChecklist');
    }
}
